import { Colors, FlexBox } from '@brg/ui';
import { LayoutConst } from 'core/modules';
import styled, { css } from 'styled-components';

//Чтоб обложка книги была равно размеру двух карточек + gap
export const BOOK_COVER_SIZE_1280 = 460;

export const CommonProjectContainer = styled.div`
  .__react_component_tooltip {
    border-radius: 6px;
    padding: 2px 8px 4px 10px !important;
    font-size: 11px !important;
    line-height: 13px !important;
    transition: none;
    opacity: 1 !important;

    ::after, ::before {
        display: none;
    }
  }
`;

export const ProjectImageWrapper = styled(FlexBox)<{
  isBooks?: boolean;
  isProjectPage?: boolean;
  isFtblMatch?: boolean;
}>`
  width: ${LayoutConst.projectCover.l.w}px;
  height: auto;
  ${({ isFtblMatch }) => !isFtblMatch && css`aspect-ratio: 1140 / 1600;`}
  box-shadow: 0px 4px 4px rgba(61, 59, 89, 0.06);
  position: relative;
  //cursor: pointer;

  @media (max-width: ${LayoutConst.screen.mac13}px), (max-height: ${LayoutConst.screen.height.projectCover}px) {
    width: ${LayoutConst.projectCover.m.w}px;
  }

  @media (max-width: 940px) {
    width: calc(100vw - 20px);
    height: ${({ isFtblMatch }) => (isFtblMatch ? 'auto' : 'calc((100vw - 20px) * 1.407)')};
    margin-top: ${({ isFtblMatch }) => (isFtblMatch ? '0' : '24px')};
  }

  ${({ isProjectPage, isFtblMatch }) => isProjectPage ? css`
    @media (max-width: 940px) {
        // width: ${LayoutConst.projectCover.s.w}px;
        // height: ${LayoutConst.projectCover.s.h}px;
      width: 100%;
      height: ${isFtblMatch ? 'auto' : '100%'};
      margin-top: 0;
    }

    @media (max-width: ${LayoutConst.screen.s - 1}px) {
      width: calc(100vw - 20px);
      height: ${isFtblMatch ? 'auto' : 'calc((100vw - 20px) * 1.407)'};
      margin-top: ${isFtblMatch ? '0' : '24px'};
    }
  ` : null};

  ${({ isBooks, isFtblMatch }) => isBooks ? css`

    // @media (max-width: ${LayoutConst.screen.l_12}px) {
    //   width: ${BOOK_COVER_SIZE_1280}px;
    //   height: ${LayoutConst.projectCover.m.h}px;
    // }

    @media (max-width: 940px) {
      width: calc(100vw - 20px);
      height: ${isFtblMatch ? 'auto' : 'calc((100vw - 20px) * 1.407)'};
      margin-top: ${isFtblMatch ? '0' : '24px'};
    } ` : null}

`;

interface IProjectLongreadWrapper {
  vtype?: string;
  showTags?: boolean;
  isBooks?: boolean;
  isBookMainPage?: boolean;
    isPresentation?: boolean;
  hseFonts?: boolean;
}

export const ProjectLongreadWrapper = styled(FlexBox)<IProjectLongreadWrapper>`
  width: ${({ vtype }) => (['fluid', 'fluid-wide', 't-shape', 'fixed-ratio-large', 'free-type'].includes(String(vtype)) ? '100%' : '1152px')};
  margin: 0 auto;

  @media (max-width: ${LayoutConst.screen.mac13}px), (max-height: ${LayoutConst.screen.height.projectCover}px) {
    width: ${({ vtype }) => {
      return (['fluid', 'fluid-wide', 't-shape', 'fixed-ratio-large', 'free-type'].includes(String(vtype)) ? '100%'
              : vtype === 'fixed-ratio-small' ? '888px'
                      : `${LayoutConst.projectContainer.m}px`)
    }
    };
    margin: 0 auto;

    ${({ isBooks }) => isBooks ? css`
      justify-content: center;
    ` : null};


  }

  ${({ isBooks, showTags }) => isBooks ? css`
    @media (max-width: ${LayoutConst.screen.l_12}px) {
      width: ${LayoutConst.projectContainer.m}px;

      @media (max-width: ${LayoutConst.screen.s}px) {
        width: 100%;
        margin-top: ${showTags ? '6' : '16'}px;
      }
    }
    @media (max-width: 834px) {
      width: 100%;
      // max-width: 760px

    }
  ` : null};


    // @media (max-width: ${LayoutConst.screen.l_12}px) {
    //   width: ${({ vtype }) => (['fluid', 'fluid-wide', 't-shape', 'fixed-ratio-large'].includes(String(vtype)) ? '100%' : '940px')};
  // }

  @media (max-width: ${LayoutConst.screen.md}px) {
    width: calc(100% - 32px);
        margin: 16px 16px 0 16px;

    ${({ isBooks }) => isBooks ? css`
      width: 100%;
      margin: 0;
      justify-content: center;
    ` : null};
  }

  @media (max-width: ${LayoutConst.screen.s - 1}px) {
    width: 100%;
    margin: 0 auto;
  }

  @media (max-width: ${LayoutConst.screen.l}px) {
    // width: calc(2 * 348px + 16px);
  }
`;

export const CommentContainer = styled.input`
  border: 1px solid rgba(0, 0, 0, 0.31);
  box-sizing: border-box;
  border-radius: 3px;
  padding: 15px 16px 104px;
  width: 100%;
  margin-bottom: 24px;
`;

export const ProjectInExamBlock = styled(FlexBox)`
    display: flex;
    flex-direction: column;
    align-items: center;
    padding: 40px 48px;
    background: ${Colors.galBlack5};
    width: 100%;
    margin-right: auto;
    margin-left: auto;
    margin-top: 24px;

    a {
        text-decoration: none;
        font-weight: 400;
        font-size: 13px;
        line-height: 16px;
        letter-spacing: -0.02em;
        color: ${Colors.galBlack47};
    }

    svg {
        width: 8px;
        height: 8px;
    }

    .competition-exam-label {
        font-size: 20px;
        font-weight: 600;
        line-height: 25px; 
        letter-spacing: -0.02em;
        color: ${Colors.galBlack47};
    }
    
    .competition-exam-title {
        font-size: 43px;
        font-weight: 600;
        line-height: 51px;
        letter-spacing: -0.02em;
        color: ${Colors.galBlack100};
    }
    
    .competition-exam-grade-result {
        div {
            font-size: 17px;
            font-weight: 400;
            line-height: 22px;
            letter-spacing: -0.02em;
            color: ${Colors.galBlack47};
        }
    }

    @media (max-width: ${LayoutConst.screen.mac13}px), (max-height: ${LayoutConst.screen.height.projectCover}px) {
        max-width: ${LayoutConst.projectContainer.m}px;
    }

    @media (max-width: ${LayoutConst.screen.md}px) {
        margin-bottom: 0;
    }
`

export const ProjectInPartBlock = styled(FlexBox)`
  display: flex;
  flex-direction: column;
  align-items: center;
  padding: 24px;
  gap: 12px;
  width: 100%;
  background: ${Colors.geoWhite100};
  // border-radius: 4px;
  margin-top: 24px;
  // margin-bottom: 24px;
  margin-right: auto;
  margin-left: auto;

  .competition-participant-label {
    font-weight: 600;
    font-size: 15px;
    line-height: 20px;
    letter-spacing: -0.02em;
    color: ${Colors.galBlack100};
  }

  a {
    text-decoration: none;
    font-weight: 600;
    font-size: 13px;
    line-height: 15px;
    letter-spacing: -0.02em;
    color: ${Colors.galBlack47};
  }

  svg {
    width: 8px;
    height: 8px;
  }

  .competition-winner-svg svg {
    width: 24px;
    height: 24px;
  }

  @media (max-width: ${LayoutConst.screen.mac13}px), (max-height: ${LayoutConst.screen.height.projectCover}px) {
    max-width: ${LayoutConst.projectContainer.m}px;
  }

  @media (max-width: ${LayoutConst.screen.md}px) {

    margin-bottom: 0;
  }

  @media (max-width: ${LayoutConst.screen.s}px) {

    .competition-participant-label {
      font-size: 17px;
      line-height: 22px;
      letter-spacing: 0;
    }
  }

  @media (max-width: ${LayoutConst.screen.xxxsm}px) {
    padding: 16px 10px;

    .competition-winner-svg svg {
      width: 40px;
      height: 40px;
    }

    .competition-participant-label {
      font-size: 17px;
      line-height: 22px;
      letter-spacing: 0;
    }
  }

    // @media(max-width: ${LayoutConst.screen.m}px) {
  //   margin-top: 16px;
  //   margin-bottom: 8px;
  // }
`;

export const ProjectInPartBlockDivider = styled(FlexBox)`
  width: 100%;
  border: 1px solid ${Colors.galBlack10};
`;

export const ProjectStatusWrapper = styled(FlexBox)`
  max-width: 270px;
  padding: 12px;
  background-color: #E7E7E7;
  border-radius: 12px;
  flex-flow: row;

  svg path {
    fill: tomato;
  }

  span {
    font-family: 'Inter';
    font-style: normal;
    font-weight: 400;
    font-size: 13px;
    line-height: 16px;
    display: flex;
    align-items: flex-end;
    color: #545453;
    user-select: none;
  }

  a {
    font-family: 'Inter';
    font-style: normal;
    font-weight: 400;
    font-size: 13px;
    line-height: 16px;
    color: #909090;
    padding-top: 12px;
  }
`;

export const PsnTitle = styled.div<{ hseFonts?: boolean }>`
  font-size: ${({ hseFonts }) => hseFonts ? 48 : 42}px;
  line-height: ${({ hseFonts }) => hseFonts ? 50 : 48}px;
  font-family: ${({ hseFonts }) => hseFonts ? 'HSE Slab' : 'Inter'};
  font-weight: ${({ hseFonts }) => hseFonts ? 400 : 600};
  letter-spacing: -0.02em;
  color: ${({ theme }) => theme.projectView.titleColor};
  max-width: 1110px;

  @media (max-width: ${LayoutConst.screen.mac13}px), (max-height: ${LayoutConst.screen.height.projectCover}px) {
    font-size: 26px;
    line-height: 32px;
    max-width: 840px;
  }

  @media (max-width: 940px) {
    font-size: 34px;
    line-height: 41px;
  }

  @media (max-width: 733px) {
    font-size: 28px;
    line-height: 34px;
  }

`;

export const StudentProjectContainer = styled(ProjectLongreadWrapper)`
  margin-top: 35px;
`;

export const ProjectStudentText = styled.div`
  font-family: 'Inter';
  font-size: 17px;
  font-style: normal;
  font-weight: 600;
  line-height: 22px; /* 129.412% */
  letter-spacing: -0.34px;
  text-align: center;
  color: ${({ theme }) => theme.projectStudent.color};

  
  @media (max-width: ${LayoutConst.screen.mac13}px), (max-height: ${LayoutConst.screen.height.projectCover}px) {
    font-size: 15px;
    line-height: 20px;
  }
`;

export const ButtonsWrapper = styled(FlexBox)<{ canEditFolders?: boolean, isProjectPage?: boolean, inActiveState?: boolean, isBottomTooltip?: boolean, isPresentationTooltip?: boolean, isPresentation?: boolean, isProjectButtons?: boolean, isDarkBg?: boolean }>`

  .dropdown-show {
    z-index: 10000;
  }
    align-items: center;

  .dropdown-button {
    svg {
      path {
        ${({isDarkBg}) => isDarkBg && 'fill: #fff;'}
      }
    }
  }

${({ canEditFolders }) => canEditFolders && css`
  [orientation] {
    overflow: visible;
  }
`};

  ${({ inActiveState }) => inActiveState ? css`
    * {
      cursor: not-allowed;
      pointer-events: none;
    }
  ` : null};

  @media (max-width: ${LayoutConst.screen.md}px) {
    .MoreButtonWrapper {
      order: initial;
    }

    .ps-action-btn {
      &:last-child {
        margin-bottom: 0;
      }
    }
  }

  @media (max-width: ${LayoutConst.screen.s - 1}px) {
    flex-direction: row;

    .MoreButtonWrapper {
      order: 10;
    }
  }

  @media (max-width: 564px) {
    .MoreButtonWrapper {
      order: 10;
    }
  }

  ${({ isProjectPage, isBottomTooltip, isPresentationTooltip }) => isProjectPage ? css`
    @media (max-width: ${LayoutConst.screen.l}px) and (min-width: ${LayoutConst.screen.s + 1}px) {
      flex-direction: row;
      flex-wrap: nowrap;
      align-items: center;
      gap: 16px;
      width: 100%;
      flex-shrink: 0;

      .ps-action-btn,
      .ps-action-moder-btn {
        margin-bottom: 0;
      }

      > div {
        margin-right: 0;
        margin-left: 0;
      }

      .likes-icon-wrapper,
      .count-icon-wrapper {
        flex-direction: row !important;
        place-items: center;

        * {
          margin-left: 0;
        }
      }

      .likes-icon-wrapper > span,
      .count-icon-wrapper span,
      .likes-count-text,
      .view-count-text {
        margin-left: 8px;
        margin-top: 0;
      }

      .MoreButtonWrapper {
        order: -1;
      }
    }

    @media (max-width: ${LayoutConst.screen.s}px) {
      flex-direction: ${isPresentationTooltip ? 'row' : 'column'};
      place-items: center;

      ${!isBottomTooltip ? css`
        padding-right: 16px;
      ` : ""}
      .ps-action-btn {
        margin-bottom: 16px;
        justify-content: center;
        padding-left: 0;
      }

      .ps-action-moder-btn {
        padding-left: 0;

        ${!isBottomTooltip ? css`
          padding-right: 0;
        ` : ""} // margin-bottom: 16px;
      }

      .likes-icon-wrapper, .count-icon-wrapper {
        flex-direction: column;

        * {
          margin-left: 0;
        }
      }

      .likes-count-text, .view-count-text {
        font-size: 13px;
        line-height: 16px;
        margin: 0 auto;
      }

      .count-icon-wrapper {
        place-items: flex-start;
      }
    }
  ` : null};
  ${({ isPresentation, isProjectButtons }) => isPresentation ? css`
   .dropdown-element-popup{
    @media (max-width: ${LayoutConst.screen.s}px) {
      right: -200px;
    }
  }
  ` : isProjectButtons ? css`
    .dropdown-element-popup{
      @media (max-width: ${LayoutConst.screen.s}px) {
        left: -85px;
      }
    }

    @media (max-width: ${LayoutConst.screen.s - 1}px) {
      flex-direction: row;
      gap: 12px;

      .MoreButtonWrapper {
        order: -1;
        margin-left: 0 !important;
      }

      .CreateProductButtonWrapper,
      .BookmarkButtonWrapper {
        margin-left: 0 !important;
      }
    }
  ` : null};
`;
import { Colors, FlexBox } from '@brg/ui';
import { LayoutConst } from 'core/modules';
import styled, { css } from 'styled-components';

//Чтоб обложка книги была равно размеру двух карточек + gap
export const BOOK_COVER_SIZE_1280 = 460;

export const CommonProjectContainer = styled.div`
  .__react_component_tooltip {
    border-radius: 6px;
    padding: 2px 8px 4px 10px !important;
    font-size: 11px !important;
    line-height: 13px !important;
    transition: none;
    opacity: 1 !important;

    ::after, ::before {
        display: none;
    }
  }
`;

export const ProjectImageWrapper = styled(FlexBox)<{
  isBooks?: boolean;
  isProjectPage?: boolean;
  isFtblMatch?: boolean;
}>`
  width: ${LayoutConst.projectCover.l.w}px;
  height: auto;
  ${({ isFtblMatch }) => !isFtblMatch && css`aspect-ratio: 1140 / 1600;`}
  box-shadow: 0px 4px 4px rgba(61, 59, 89, 0.06);
  position: relative;
  //cursor: pointer;

  @media (max-width: ${LayoutConst.screen.mac13}px), (max-height: ${LayoutConst.screen.height.projectCover}px) {
    width: ${LayoutConst.projectCover.m.w}px;
  }

  @media (max-width: 940px) {
    width: calc(100vw - 20px);
    height: ${({ isFtblMatch }) => (isFtblMatch ? 'auto' : 'calc((100vw - 20px) * 1.407)')};
    margin-top: ${({ isFtblMatch }) => (isFtblMatch ? '0' : '24px')};
  }

  ${({ isProjectPage, isFtblMatch }) => isProjectPage ? css`
    @media (max-width: 940px) {
        // width: ${LayoutConst.projectCover.s.w}px;
        // height: ${LayoutConst.projectCover.s.h}px;
      width: 100%;
      height: ${isFtblMatch ? 'auto' : '100%'};
      margin-top: 0;
    }

    @media (max-width: ${LayoutConst.screen.s - 1}px) {
      width: calc(100vw - 20px);
      height: ${isFtblMatch ? 'auto' : 'calc((100vw - 20px) * 1.407)'};
      margin-top: ${isFtblMatch ? '0' : '24px'};
    }
  ` : null};

  ${({ isBooks, isFtblMatch }) => isBooks ? css`

    // @media (max-width: ${LayoutConst.screen.l_12}px) {
    //   width: ${BOOK_COVER_SIZE_1280}px;
    //   height: ${LayoutConst.projectCover.m.h}px;
    // }

    @media (max-width: 940px) {
      width: calc(100vw - 20px);
      height: ${isFtblMatch ? 'auto' : 'calc((100vw - 20px) * 1.407)'};
      margin-top: ${isFtblMatch ? '0' : '24px'};
    } ` : null}

`;

interface IProjectLongreadWrapper {
  vtype?: string;
  showTags?: boolean;
  isBooks?: boolean;
  isBookMainPage?: boolean;
    isPresentation?: boolean;
  hseFonts?: boolean;
}

export const ProjectLongreadWrapper = styled(FlexBox)<IProjectLongreadWrapper>`
  width: ${({ vtype }) => (['fluid', 'fluid-wide', 't-shape', 'fixed-ratio-large', 'free-type'].includes(String(vtype)) ? '100%' : '1152px')};
  margin: 0 auto;

  @media (max-width: ${LayoutConst.screen.mac13}px), (max-height: ${LayoutConst.screen.height.projectCover}px) {
    width: ${({ vtype }) => {
      return (['fluid', 'fluid-wide', 't-shape', 'fixed-ratio-large', 'free-type'].includes(String(vtype)) ? '100%'
              : vtype === 'fixed-ratio-small' ? '888px'
                      : `${LayoutConst.projectContainer.m}px`)
    }
    };
    margin: 0 auto;

    ${({ isBooks }) => isBooks ? css`
      justify-content: center;
    ` : null};


  }

  ${({ isBooks, showTags }) => isBooks ? css`
    @media (max-width: ${LayoutConst.screen.l_12}px) {
      width: ${LayoutConst.projectContainer.m}px;

      @media (max-width: ${LayoutConst.screen.s}px) {
        width: 100%;
        margin-top: ${showTags ? '6' : '16'}px;
      }
    }
    @media (max-width: 834px) {
      width: 100%;
      // max-width: 760px

    }
  ` : null};


    // @media (max-width: ${LayoutConst.screen.l_12}px) {
    //   width: ${({ vtype }) => (['fluid', 'fluid-wide', 't-shape', 'fixed-ratio-large'].includes(String(vtype)) ? '100%' : '940px')};
  // }

  @media (max-width: ${LayoutConst.screen.md}px) {
    width: calc(100% - 32px);
        margin: 16px 16px 0 16px;

    ${({ isBooks }) => isBooks ? css`
      width: 100%;
      margin: 0;
      justify-content: center;
    ` : null};
  }

  @media (max-width: ${LayoutConst.screen.s - 1}px) {
    width: 100%;
    margin: 0 auto;
  }

  @media (max-width: ${LayoutConst.screen.l}px) {
    // width: calc(2 * 348px + 16px);
  }
`;

export const CommentContainer = styled.input`
  border: 1px solid rgba(0, 0, 0, 0.31);
  box-sizing: border-box;
  border-radius: 3px;
  padding: 15px 16px 104px;
  width: 100%;
  margin-bottom: 24px;
`;

export const ProjectInExamBlock = styled(FlexBox)`
    display: flex;
    flex-direction: column;
    align-items: center;
    padding: 40px 48px;
    background: ${Colors.galBlack5};
    width: 100%;
    margin-right: auto;
    margin-left: auto;
    margin-top: 24px;

    a {
        text-decoration: none;
        font-weight: 400;
        font-size: 13px;
        line-height: 16px;
        letter-spacing: -0.02em;
        color: ${Colors.galBlack47};
    }

    svg {
        width: 8px;
        height: 8px;
    }

    .competition-exam-label {
        font-size: 20px;
        font-weight: 600;
        line-height: 25px; 
        letter-spacing: -0.02em;
        color: ${Colors.galBlack47};
    }
    
    .competition-exam-title {
        font-size: 43px;
        font-weight: 600;
        line-height: 51px;
        letter-spacing: -0.02em;
        color: ${Colors.galBlack100};
    }
    
    .competition-exam-grade-result {
        div {
            font-size: 17px;
            font-weight: 400;
            line-height: 22px;
            letter-spacing: -0.02em;
            color: ${Colors.galBlack47};
        }
    }

    @media (max-width: ${LayoutConst.screen.mac13}px), (max-height: ${LayoutConst.screen.height.projectCover}px) {
        max-width: ${LayoutConst.projectContainer.m}px;
    }

    @media (max-width: ${LayoutConst.screen.md}px) {
        margin-bottom: 0;
    }
`

export const ProjectInPartBlock = styled(FlexBox)`
  display: flex;
  flex-direction: column;
  align-items: center;
  padding: 24px;
  gap: 12px;
  width: 100%;
  background: ${Colors.geoWhite100};
  // border-radius: 4px;
  margin-top: 24px;
  // margin-bottom: 24px;
  margin-right: auto;
  margin-left: auto;

  .competition-participant-label {
    font-weight: 600;
    font-size: 15px;
    line-height: 20px;
    letter-spacing: -0.02em;
    color: ${Colors.galBlack100};
  }

  a {
    text-decoration: none;
    font-weight: 600;
    font-size: 13px;
    line-height: 15px;
    letter-spacing: -0.02em;
    color: ${Colors.galBlack47};
  }

  svg {
    width: 8px;
    height: 8px;
  }

  .competition-winner-svg svg {
    width: 24px;
    height: 24px;
  }

  @media (max-width: ${LayoutConst.screen.mac13}px), (max-height: ${LayoutConst.screen.height.projectCover}px) {
    max-width: ${LayoutConst.projectContainer.m}px;
  }

  @media (max-width: ${LayoutConst.screen.md}px) {

    margin-bottom: 0;
  }

  @media (max-width: ${LayoutConst.screen.s}px) {

    .competition-participant-label {
      font-size: 17px;
      line-height: 22px;
      letter-spacing: 0;
    }
  }

  @media (max-width: ${LayoutConst.screen.xxxsm}px) {
    padding: 16px 10px;

    .competition-winner-svg svg {
      width: 40px;
      height: 40px;
    }

    .competition-participant-label {
      font-size: 17px;
      line-height: 22px;
      letter-spacing: 0;
    }
  }

    // @media(max-width: ${LayoutConst.screen.m}px) {
  //   margin-top: 16px;
  //   margin-bottom: 8px;
  // }
`;

export const ProjectInPartBlockDivider = styled(FlexBox)`
  width: 100%;
  border: 1px solid ${Colors.galBlack10};
`;

export const ProjectStatusWrapper = styled(FlexBox)`
  max-width: 270px;
  padding: 12px;
  background-color: #E7E7E7;
  border-radius: 12px;
  flex-flow: row;

  svg path {
    fill: tomato;
  }

  span {
    font-family: 'Inter';
    font-style: normal;
    font-weight: 400;
    font-size: 13px;
    line-height: 16px;
    display: flex;
    align-items: flex-end;
    color: #545453;
    user-select: none;
  }

  a {
    font-family: 'Inter';
    font-style: normal;
    font-weight: 400;
    font-size: 13px;
    line-height: 16px;
    color: #909090;
    padding-top: 12px;
  }
`;

export const PsnTitle = styled.div<{ hseFonts?: boolean }>`
  font-size: ${({ hseFonts }) => hseFonts ? 48 : 42}px;
  line-height: ${({ hseFonts }) => hseFonts ? 50 : 48}px;
  font-family: ${({ hseFonts }) => hseFonts ? 'HSE Slab' : 'Inter'};
  font-weight: ${({ hseFonts }) => hseFonts ? 400 : 600};
  letter-spacing: -0.02em;
  color: ${({ theme }) => theme.projectView.titleColor};
  max-width: 1110px;

  @media (max-width: ${LayoutConst.screen.mac13}px), (max-height: ${LayoutConst.screen.height.projectCover}px) {
    font-size: 26px;
    line-height: 32px;
    max-width: 840px;
  }

  @media (max-width: 940px) {
    font-size: 34px;
    line-height: 41px;
  }

  @media (max-width: 733px) {
    font-size: 28px;
    line-height: 34px;
  }

`;

export const StudentProjectContainer = styled(ProjectLongreadWrapper)`
  margin-top: 35px;
`;

export const ProjectStudentText = styled.div`
  font-family: 'Inter';
  font-size: 17px;
  font-style: normal;
  font-weight: 600;
  line-height: 22px; /* 129.412% */
  letter-spacing: -0.34px;
  text-align: center;
  color: ${({ theme }) => theme.projectStudent.color};

  
  @media (max-width: ${LayoutConst.screen.mac13}px), (max-height: ${LayoutConst.screen.height.projectCover}px) {
    font-size: 15px;
    line-height: 20px;
  }
`;

export const ButtonsWrapper = styled(FlexBox)<{ canEditFolders?: boolean, isProjectPage?: boolean, inActiveState?: boolean, isBottomTooltip?: boolean, isPresentationTooltip?: boolean, isPresentation?: boolean, isProjectButtons?: boolean, isDarkBg?: boolean }>`

  .dropdown-show {
    z-index: 10000;
  }
    align-items: center;

  .dropdown-button {
    svg {
      path {
        ${({isDarkBg}) => isDarkBg && 'fill: #fff;'}
      }
    }
  }

${({ canEditFolders }) => canEditFolders && css`
  [orientation] {
    overflow: visible;
  }
`};

  ${({ inActiveState }) => inActiveState ? css`
    * {
      cursor: not-allowed;
      pointer-events: none;
    }
  ` : null};

  @media (max-width: ${LayoutConst.screen.md}px) {
    .MoreButtonWrapper {
      order: initial;
    }

    .ps-action-btn {
      &:last-child {
        margin-bottom: 0;
      }
    }
  }

  @media (max-width: ${LayoutConst.screen.s - 1}px) {
    flex-direction: row;

    .MoreButtonWrapper {
      order: 10;
    }
  }

  @media (max-width: 564px) {
    .MoreButtonWrapper {
      order: 10;
    }
  }

  ${({ isProjectPage, isBottomTooltip, isPresentationTooltip }) => isProjectPage ? css`
    @media (max-width: ${LayoutConst.screen.l}px) and (min-width: ${LayoutConst.screen.s + 1}px) {
      flex-direction: row;
      flex-wrap: nowrap;
      align-items: center;
      gap: 16px;
      width: 100%;
      flex-shrink: 0;

      .ps-action-btn,
      .ps-action-moder-btn {
        margin-bottom: 0;
      }

      > div {
        margin-right: 0;
        margin-left: 0;
      }

      .likes-icon-wrapper,
      .count-icon-wrapper {
        flex-direction: row !important;
        place-items: center;

        * {
          margin-left: 0;
        }
      }

      .likes-icon-wrapper > span,
      .count-icon-wrapper span,
      .likes-count-text,
      .view-count-text {
        margin-left: 8px;
        margin-top: 0;
      }

      .MoreButtonWrapper {
        order: -1;
      }
    }

    @media (max-width: ${LayoutConst.screen.s}px) {
      flex-direction: ${isPresentationTooltip ? 'row' : 'column'};
      place-items: center;

      ${!isBottomTooltip ? css`
        padding-right: 16px;
      ` : ""}
      .ps-action-btn {
        margin-bottom: 16px;
        justify-content: center;
        padding-left: 0;
      }

      .ps-action-moder-btn {
        padding-left: 0;

        ${!isBottomTooltip ? css`
          padding-right: 0;
        ` : ""} // margin-bottom: 16px;
      }

      .likes-icon-wrapper, .count-icon-wrapper {
        flex-direction: column;

        * {
          margin-left: 0;
        }
      }

      .likes-count-text, .view-count-text {
        font-size: 13px;
        line-height: 16px;
        margin: 0 auto;
      }

      .count-icon-wrapper {
        place-items: flex-start;
      }
    }
  ` : null};
  ${({ isPresentation, isProjectButtons }) => isPresentation ? css`
   .dropdown-element-popup{
    @media (max-width: ${LayoutConst.screen.s}px) {
      right: -200px;
    }
  }
  ` : isProjectButtons ? css`
    .dropdown-element-popup{
      @media (max-width: ${LayoutConst.screen.s}px) {
        left: -85px;
      }
    }

    @media (max-width: ${LayoutConst.screen.s - 1}px) {
      flex-direction: row;
      gap: 12px;

      .MoreButtonWrapper {
        order: -1;
        margin-left: 0 !important;
      }

      .CreateProductButtonWrapper,
      .BookmarkButtonWrapper {
        margin-left: 0 !important;
      }
    }
  ` : null};
`;
